import styled from 'styled-components'

export const Container = styled.div`
    border-radius: inherit;
    overflow: hidden;
    pointer-events: none;
    position: relative;
`

export const Dim = styled.div`
    backdrop-filter: grayscale(1);
    background: rgba(0, 0, 0, 0.7);
    position: absolute;
`
